export interface Country {
  name: string;
  dial: string;
  flag: string;
}

export const COUNTRIES: Country[] = [
  { name: 'United States', dial: '+1', flag: '🇺🇸' },
  { name: 'Canada', dial: '+1', flag: '🇨🇦' },
  { name: 'United Kingdom', dial: '+44', flag: '🇬🇧' },
  { name: 'Australia', dial: '+61', flag: '🇦🇺' },
  { name: 'New Zealand', dial: '+64', flag: '🇳🇿' },
  { name: 'Ireland', dial: '+353', flag: '🇮🇪' },
  { name: 'Germany', dial: '+49', flag: '🇩🇪' },
  { name: 'France', dial: '+33', flag: '🇫🇷' },
  { name: 'Italy', dial: '+39', flag: '🇮🇹' },
  { name: 'Spain', dial: '+34', flag: '🇪🇸' },
  { name: 'Netherlands', dial: '+31', flag: '🇳🇱' },
  { name: 'Belgium', dial: '+32', flag: '🇧🇪' },
  { name: 'Switzerland', dial: '+41', flag: '🇨🇭' },
  { name: 'Austria', dial: '+43', flag: '🇦🇹' },
  { name: 'Sweden', dial: '+46', flag: '🇸🇪' },
  { name: 'Norway', dial: '+47', flag: '🇳🇴' },
  { name: 'Denmark', dial: '+45', flag: '🇩🇰' },
  { name: 'Finland', dial: '+358', flag: '🇫🇮' },
  { name: 'Portugal', dial: '+351', flag: '🇵🇹' },
  { name: 'Greece', dial: '+30', flag: '🇬🇷' },
  { name: 'Poland', dial: '+48', flag: '🇵🇱' },
  { name: 'Czech Republic', dial: '+420', flag: '🇨🇿' },
  { name: 'Hungary', dial: '+36', flag: '🇭🇺' },
  { name: 'Romania', dial: '+40', flag: '🇷🇴' },
  { name: 'Luxembourg', dial: '+352', flag: '🇱🇺' },
  { name: 'Malta', dial: '+356', flag: '🇲🇹' },
  { name: 'Cyprus', dial: '+357', flag: '🇨🇾' },
  { name: 'Japan', dial: '+81', flag: '🇯🇵' },
  { name: 'South Korea', dial: '+82', flag: '🇰🇷' },
  { name: 'Singapore', dial: '+65', flag: '🇸🇬' },
  { name: 'Hong Kong', dial: '+852', flag: '🇭🇰' },
  { name: 'Taiwan', dial: '+886', flag: '🇹🇼' },
  { name: 'China', dial: '+86', flag: '🇨🇳' },
  { name: 'India', dial: '+91', flag: '🇮🇳' },
  { name: 'Malaysia', dial: '+60', flag: '🇲🇾' },
  { name: 'Indonesia', dial: '+62', flag: '🇮🇩' },
  { name: 'Philippines', dial: '+63', flag: '🇵🇭' },
  { name: 'Vietnam', dial: '+84', flag: '🇻🇳' },
  { name: 'Thailand', dial: '+66', flag: '🇹🇭' },
  { name: 'United Arab Emirates', dial: '+971', flag: '🇦🇪' },
  { name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦' },
  { name: 'Qatar', dial: '+974', flag: '🇶🇦' },
  { name: 'Israel', dial: '+972', flag: '🇮🇱' },
  { name: 'Turkey', dial: '+90', flag: '🇹🇷' },
  { name: 'South Africa', dial: '+27', flag: '🇿🇦' },
  { name: 'Egypt', dial: '+20', flag: '🇪🇬' },
  { name: 'Morocco', dial: '+212', flag: '🇲🇦' },
  { name: 'Kenya', dial: '+254', flag: '🇰🇪' },
  { name: 'Nigeria', dial: '+234', flag: '🇳🇬' },
  { name: 'Brazil', dial: '+55', flag: '🇧🇷' },
  { name: 'Argentina', dial: '+54', flag: '🇦🇷' },
  { name: 'Chile', dial: '+56', flag: '🇨🇱' },
  { name: 'Colombia', dial: '+57', flag: '🇨🇴' },
  { name: 'Peru', dial: '+51', flag: '🇵🇪' },
  { name: 'Mexico', dial: '+52', flag: '🇲🇽' },
  { name: 'Russia', dial: '+7', flag: '🇷🇺' },
  { name: 'Ukraine', dial: '+380', flag: '🇺🇦' },
];